// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__n_uBR","container":"styles_container__3TJp7","title":"styles_title__2RO1s","wrapper":"styles_wrapper__3Pt46","answer":"styles_answer__ATAVS"};